import Region from '@/creditflowresearch/domain/Region';

const getEmRegionPrefixForTitle = (regionIds: string[], separator: string = ' '): string => {
  if (regionIds.length === 1) {
    const [regionId] = regionIds;
    const emDisplayName = Region.from(regionId)?.getEmDisplayName()?.toUpperCase();

    if (!emDisplayName) {
      return '';
    }

    return emDisplayName + separator;
  }

  return '';
};

export default getEmRegionPrefixForTitle;
